import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
  standalone: true,
  imports: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumericInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class NumericInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() controlId: string | null = null;
  @Input() min: number | null = 0;
  @Input() max: number | null = null;
  @Input() error: boolean = false;
  @Output() valueChange = new EventEmitter<number | null>();

  public value: number | null = null;
  public disabled: boolean = false;

  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  public writeValue(value: number | null): void {
    this.value = value;
  }

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue === '') {
      this.value = null;
      this.valueChange.emit(null);
      this.onChange(null);
      return;
    }

    const numericValue = +inputValue;
    this.value = numericValue;
    this.valueChange.emit(isNaN(numericValue) ? null : numericValue);
    this.onChange(isNaN(numericValue) ? null : numericValue);
  }

  public registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
